import React, {useEffect} from 'react';

import {Button, Icon, IconButton} from '@mui/material';
import {CloudDownload, Download} from '@mui/icons-material';
import ContextElementFunctions from '../../Contexts/ContextElementFunctions';
import {downloadFile, downloadFolder} from './background_tasks';

interface DownloadFileFunctionProps {
  onDownloadStart?: () => void;
}

export const DownloadFileFunction: React.FC<DownloadFileFunctionProps> = ({onDownloadStart}) => {
  const {dir_id, type, name} = React.useContext(ContextElementFunctions);

  const download_file = () => {
    onDownloadStart?.();
    downloadFile(dir_id, name);
  };

  const download_folder = () => {
    onDownloadStart?.();
    downloadFolder(dir_id, name);
  };
  const download = () => {
    if (type === 'dir') {
      download_folder();
    } else {
      download_file();
    }
  };

  return (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          download();
        }}
        title={type === 'dir' ? 'Ordner als .zip herunterladen' : 'Datei herunterladen'}>
        <CloudDownload />
      </IconButton>
      {/* <p>{dir_id}</p> */}
    </>
  );
};
